"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.styles = void 0;var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));var _Emotion = require("../../lib/theming/Emotion");



var _helpers = require("./helpers");var _templateObject, _templateObject2;

var styles = exports.styles = (0, _Emotion.memoizeStyle)({
  rootSmall: function rootSmall(t) {
    return tabsRoot(t, 'small');
  },

  rootMedium: function rootMedium(t) {
    return tabsRoot(t, 'medium');
  },

  rootLarge: function rootLarge(t) {
    return tabsRoot(t, 'large');
  },

  vertical: function vertical() {
    return (0, _Emotion.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n      margin: 0;\n    "])));


  }
});

function tabsRoot(t, size) {
  return (0, _Emotion.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: inline-block;\n    margin: 0 -", ";\n    padding: 0;\n    position: relative;\n  "])),

  (0, _helpers.paddingX)(t, size));



}